export var PREVIOUS_DIRECTION = 'previous';
export var NEXT_DIRECTION = 'next';
export var PREVIOUS_DIRECTION_ICON = 'chevron left';
export var NEXT_DIRECTION_ICON = 'chevron right';